import type { GuideCarouselCardData } from '@module/types/card/type';
import type React from 'react';

interface GuideCarouselCardProps {
  data: GuideCarouselCardData;
  additionalElements?: React.ReactNode;
  continueList?: boolean;
}

function GuideCarouselCard({ data, continueList = false, additionalElements }: GuideCarouselCardProps) {
  return (
    <div className='relative flex h-full items-center justify-center rounded-2xl bg-colorBg01'>
      <div className='min-h-[444px] w-[485px]'>
        {data.contents.map((item, idx) => (
          <div key={item.explanationSentenceList[0]} className='mb-10'>
            <h4 className='mb-4 text-colorFg18 text-xl'>{item.title}</h4>
            <p className='mb-4 whitespace-pre-wrap text-colorFg01'>{item.subTitle}</p>
            {item.explanationSentenceList.map((sentence, order) => {
              if (!sentence) return;
              return (
                <div key={sentence} className='relative mb-3 flex items-center'>
                  <div className='absolute top-0 h-6 w-6 rounded-full bg-red-500 text-center text-white'>
                    {idx !== 0 && continueList
                      ? data.contents[idx - 1].explanationSentenceList.length + order + 1
                      : order + 1}
                  </div>
                  <span className='ml-3 whitespace-pre-wrap pl-6 text-baseFg'>{sentence}</span>
                </div>
              );
            })}
          </div>
        ))}
        {additionalElements}
      </div>
      <div>
        <img src={data.imgSrc} alt='guideimg' />
      </div>
      {data.rightBottomText && (
        <div className='absolute right-5 bottom-5 text-[#777] text-sm'>{data.rightBottomText}</div>
      )}
    </div>
  );
}

export default GuideCarouselCard;
